import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Check } from 'lucide-react';
export function Offer() {
  const includes = ['20 módulos PDF completos', '10 bonos imprimibles', 'Blend Book completo con 50 mezclas aromáticas', 'Catálogo 8 aromas con precios y descripciones', 'Calculadora de costos', '50 descripciones listas para publicar'];
  return <section id="oferta" className="bg-brand-bg py-14" data-id="element-83">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-xl border border-brand-line/30 overflow-hidden" data-id="element-85">
          <div className="bg-brand-accent/30 py-8 px-8 text-center border-b border-brand-line/20" data-id="element-86">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-text" data-id="element-87">
              LA OFERTA
            </h2>
          </div>

          <div className="p-8 md:p-12" data-id="element-88">
            <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12" data-id="element-89">
              <div className="w-full md:w-1/2 space-y-4" data-id="element-90">
                <div className="flex justify-between items-center pb-4 border-b border-brand-line/20" data-id="element-91">
                  <span className="text-brand-subtext" data-id="element-92">
                    Valor Total del Paquete
                  </span>
                  <span className="text-xl font-semibold line-through text-brand-subtext/70" data-id="element-93">
                    $278
                  </span>
                </div>
                <div className="flex justify-between items-center pb-4 border-b border-brand-line/20" data-id="element-94">
                  <span className="text-brand-subtext" data-id="element-95">Precio Regular</span>
                  <span className="text-xl font-semibold line-through text-brand-subtext/70" data-id="element-96">
                    $27
                  </span>
                </div>
                <div className="flex justify-between items-center pt-2" data-id="element-97">
                  <span className="text-2xl font-bold text-brand-text" data-id="element-98">
                    Hoy
                  </span>
                  <span className="text-4xl font-bold text-brand-ctaStart" data-id="element-99">
                    $17
                  </span>
                </div>
              </div>

              <div className="w-full md:w-1/2 bg-brand-bg p-6 rounded-2xl border border-brand-line/20" data-id="element-100">
                <p className="font-bold text-brand-text mb-4" data-id="element-101">
                  Lo que obtienes:
                </p>
                <ul className="space-y-3" data-id="element-102">
                  {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-103">
                      <Check className="w-5 h-5 text-brand-ctaStart flex-shrink-0 mt-0.5" data-id="element-104" />
                      <span className="text-sm text-brand-text" data-id="element-105">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="text-center" data-id="element-106">
              <CTAButton className="w-full md:w-auto text-xl px-12 py-5" data-id="element-107">
                COMPRAR AHORA —{' '}
                <span className="line-through opacity-60 mr-1" data-id="element-108">$27</span> $17
              </CTAButton>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}